module.exports = __webpack_public_path__ + "img/heather.0455698a.svg";